import { DocumentPaTraductionUpdateOrder } from "./document-pa-traduction-update-order.entity";

export class GenericUpdateTraductionStepOrder {

	id!: number;
	traductions: DocumentPaTraductionUpdateOrder[] = [];

}
